import React from 'react';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div>
          <div className="site-footer__brandline">
            <span className="site-brand__mark" aria-hidden="true">
              <img src="/logo.svg" alt="" />
            </span>
            <span>WP-Autoplugin</span>
            <span className="site-brand__version">v2</span>
          </div>
          <p className="site-footer__legal">
            © {new Date().getFullYear()} WP-Autoplugin. Not affiliated with WordPress,
            Automattic Inc., or the WordPress Foundation. WordPress is a registered
            trademark of the WordPress Foundation.
          </p>
        </div>
        <div className="site-footer__links">
          <a href="/about">About</a>
          <a href="/tools/hooks-extractor">Hooks extractor</a>
          <a href="https://github.com/WP-Autoplugin/wp-autoplugin" target="_blank" rel="noopener noreferrer">GitHub</a>
          <a href="https://github.com/WP-Autoplugin/wp-autoplugin/releases" target="_blank" rel="noopener noreferrer">Releases</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
